import nineteenNineteenLogo from '../assets/logos/1919.png'
import bandonDunesLogo from '../assets/logos/bandon-dunes.png'
import blackWolfLogo from '../assets/logos/blackwolf-run.png'
import cabotLogo from '../assets/logos/cabot.png'
import clearLogo from '../assets/logos/clear.svg'
import deerValleyLogo from '../assets/logos/deer-valley.svg'
import forbesLogo from '../assets/logos/forbes.svg'
import golfDigestLogo from '../assets/logos/golf-digest.svg'
import golfMaxLogo from '../assets/logos/golf-max.svg'
import golfLogo from '../assets/logos/golf.svg'
import ikonPassLogo from '../assets/logos/ikon-pass.svg'
import logoImg from '../assets/logos/logo.svg'
import luggageFreeDarkLogo from '../assets/logos/luggage-free-dark.svg'
import luggageFreeLogo from '../assets/logos/luggage-free.svg'
import movingMountainsLogo from '../assets/logos/moving-mountains.svg'
import nbcGolfLogo from '../assets/logos/nbc-golf.svg'
import shipCampsDarkLogo from '../assets/logos/ship-camps-dark.svg'
import shipCampsTextOnlyDarkLogo from '../assets/logos/ship-camps-text-only-dark.svg'
import shipCampsTextOnlyLogo from '../assets/logos/ship-camps-text-only.svg'
import shipCampsLogo from '../assets/logos/ship-camps.svg'
import shipGoDarkLogo from '../assets/logos/ship-go-dark.svg'
import shipGoLogo from '../assets/logos/ship-go.svg'
import shipPlayDarkLogo from '../assets/logos/ship-play-dark.svg'
import shipPlayTextOnlyDarkLogo from '../assets/logos/ship-play-text-only-dark.svg'
import shipPlayTextOnlyLogo from '../assets/logos/ship-play-text-only.svg'
import shipPlayLogo from '../assets/logos/ship-play.svg'
import shipSchoolsDarkLogo from '../assets/logos/ship-schools-dark.svg'
import shipSchoolsTextOnlyDarkLogo from '../assets/logos/ship-schools-text-only-dark.svg'
import shipSchoolsTextOnlyLogo from '../assets/logos/ship-schools-text-only.svg'
import shipSchoolsLogo from '../assets/logos/ship-schools.svg'
import shipSkisDarkLogo from '../assets/logos/ship-skis-dark.svg'
import shipSkisTextOnlyDarkLogo from '../assets/logos/ship-skis-text-only-dark.svg'
import shipSkisTextOnlyLogo from '../assets/logos/ship-skis-text-only.svg'
import shipSkisLogo from '../assets/logos/ship-skis.svg'
import shipSticksDarkLogo from '../assets/logos/ship-sticks-dark.svg'
import shipSticksTextOnlyDarkLogo from '../assets/logos/ship-sticks-text-only-dark.svg'
import shipSticksTextOnlyLogo from '../assets/logos/ship-sticks-text-only.svg'
import shipSticksLogo from '../assets/logos/ship-sticks.svg'
import streamSongLogo from '../assets/logos/streamsong.png'
import theGantAspenLogo from '../assets/logos/the-gant-aspen.svg'
import usaTodayLogo from '../assets/logos/usa-today.svg'
import viceroySnowmassLogo from '../assets/logos/viceroy-snowmass.svg'
import whistlingStraitsLogo from '../assets/logos/whistling-straits.png'

export const brandLogos: { [key: string]: any } = {
  shipplay: shipPlayLogo,
  shipplaytextonly: shipPlayTextOnlyLogo,
  shipplaytextonlydark: shipPlayTextOnlyDarkLogo,
  shipplaydark: shipPlayDarkLogo,
  shipsticks: shipSticksLogo,
  shipsticksdark: shipSticksDarkLogo,
  shipstickstextonly: shipSticksTextOnlyLogo,
  shipstickstextonlydark: shipSticksTextOnlyDarkLogo,
  shipskis: shipSkisLogo,
  shipskisdark: shipSkisDarkLogo,
  shipskistextonly: shipSkisTextOnlyLogo,
  shipskistextonlydark: shipSkisTextOnlyDarkLogo,
  shipcamps: shipCampsLogo,
  shipcampsdark: shipCampsDarkLogo,
  shipcampstextonly: shipCampsTextOnlyLogo,
  shipcampstextonlydark: shipCampsTextOnlyDarkLogo,
  shipschools: shipSchoolsLogo,
  shipschoolsdark: shipSchoolsDarkLogo,
  shipschoolstextonly: shipSchoolsTextOnlyLogo,
  shipschoolstextonlydark: shipSchoolsTextOnlyDarkLogo,
  luggagefree: luggageFreeLogo,
  luggagefreedark: luggageFreeDarkLogo,
  shipgo: shipGoLogo,
  shipgodark: shipGoDarkLogo,
  logo: logoImg,
  forbes: forbesLogo,
  golfdigest: golfDigestLogo,
  golfmax: golfMaxLogo,
  golf: golfLogo,
  nbcgolf: nbcGolfLogo,
  usatoday: usaTodayLogo,
  cabot: cabotLogo,
  streamsong: streamSongLogo,
  nineteen19: nineteenNineteenLogo,
  whistlingstraits: whistlingStraitsLogo,
  bandondunes: bandonDunesLogo,
  blackwolfrun: blackWolfLogo,
  clear: clearLogo,
  deervalley: deerValleyLogo,
  ikonpass: ikonPassLogo,
  movingmountains: movingMountainsLogo,
  thegantaspen: theGantAspenLogo,
  viceroysnowmass: viceroySnowmassLogo,
}

/**
 * Brand logo settings.
 */

export const shipplay = {
  width: '120',
  height: '40',
}

export const shipplaydark = {
  width: '170',
  height: '40',
}

export const shipplaytextonly = {
  width: '120',
  height: '40',
}

export const shipplaytextonlydark = {
  width: '76',
  height: '18',
}

export const shipsticks = {
  width: '120',
  height: '40',
}

export const shipsticksdark = {
  width: '109',
  height: '48',
}

export const shipstickstextonly = {
  width: '120',
  height: '40',
}

export const shipstickstextonlydark = {
  width: '76',
  height: '18',
}

export const shipskis = {
  width: '102',
  height: '40',
}

export const shipskisdark = {
  width: '94',
  height: '48',
}

export const shipskistextonly = {
  width: '120',
  height: '40',
}

export const shipskistextonlydark = {
  width: '76',
  height: '18',
}

export const shipcamps = {
  width: '120',
  height: '40',
}

export const shipcampsdark = {
  width: '112',
  height: '48',
}

export const shipcampstextonlydark = {
  width: '84',
  height: '18',
}

export const shipschools = {
  width: '112',
  height: '48',
}

export const shipschoolsdark = {
  width: '112',
  height: '48',
}

export const shipschoolstextonlydark = {
  width: '87',
  height: '18',
}

export const luggagefree = {
  width: '120',
  height: '40',
}

export const luggagefreedark = {
  width: '189',
  height: '40',
}

export const shipgo = {
  width: '120',
  height: '40',
}

export const shipgodark = {
  width: '114',
  height: '40',
}

export const logo = {
  width: '120',
  height: '40',
}

export const forbes = {
  width: '120',
  height: '40',
}

export const golfdigest = {
  width: '120',
  height: '40',
}

export const golfmax = {
  width: '120',
  height: '40',
}

export const golf = {
  width: '120',
  height: '40',
}

export const nbcgolf = {
  width: '120',
  height: '40',
}

export const usatoday = {
  width: '120',
  height: '40',
}

export const cabot = {
  width: '120',
  height: '40',
}

export const streamsong = {
  width: '120',
  height: '40',
}

export const nineteen19 = {
  width: '120',
  height: '40',
}

export const whistlingstraits = {
  width: '120',
  height: '40',
}

export const bandondunes = {
  width: '120',
  height: '40',
}

export const blackwolfrun = {
  width: '120',
  height: '40',
}

export const clear = {
  width: '120',
  height: '40',
}

export const deervalley = {
  width: '120',
  height: '40',
}

export const ikonpass = {
  width: '120',
  height: '40',
}

export const movingmountains = {
  width: '120',
  height: '40',
}

export const thegantaspen = {
  width: '120',
  height: '40',
}

export const viceroysnowmass = {
  width: '120',
  height: '40',
}
